@let loading = loading$ | async;
@let canChangeVisibility = canChangeVisibility$ | async;

<div class="mb-3">
    <form role="search">
        <label for="search" class="mb-2" i18n>Full-text search</label>
        <div class="row mb-3">
            <div class="input-group">
                <span class="input-group-text" role="status">
                    @if (loading) {
                    <div class="spinner-border spinner-border-sm">
                        <span class="visually-hidden" i18n>Searching...</span>
                    </div>
                    } @else {
                    <fa-icon [icon]="faSearch" />
                    }
                </span>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search..."
                    [formControl]="form.controls.text"
                    i18n-placeholder
                />
            </div>
        </div>

        <div class="filter-grid mb-3">
            <label for="dataset" class="form-label" i18n>Dataset</label>
            <la-filter-select
                [formControl]="form.controls.dataset"
                [options]="datasetOptions"
            />

            <label for="entailment-label" class="form-label" i18n
                >Entailment label</label
            >
            <la-filter-select
                [formControl]="form.controls.entailmentLabel"
                [options]="entailmentLabelOptions"
            />

            <div>
                <label for="annotator" class="form-label me-2" i18n>
                    Status
                </label>
                <fa-icon
                    role="button"
                    size="sm"
                    [icon]="faCircleInfo"
                    (click)="showStatusInfoModal()"
                    title="Show status info"
                    i18n-title
                />
            </div>
            <la-filter-select
                [formControl]="form.controls.status"
                [options]="statusOptions"
            />

            @if (canChangeVisibility) {
            <label for="hidden" class="form-label" i18n>Visibility</label>
            <la-filter-select
                [formControl]="form.controls.hidden"
                [options]="hiddenOptions"
            />
            }

            <label for="langpro-prediction" class="form-label" i18n>LangPro prediction</label>
            <la-filter-select
                [formControl]="form.controls.langproPrediction"
                [options]="langproPredictionOptions"
            />
        </div>

        <div class="row col-12 mx-auto">
            <la-icon-button
                [icon]="faTimes"
                label="Clear filters"
                class="px-0"
                size="sm"
                buttonStyle="danger"
                (click)="clearFilters()"
                i18n-label
                outline
                fullWidth
            />
        </div>
    </form>
</div>
